module.exports = __webpack_public_path__ + "static/media/billbord_empty.fb7e2c63.jpg";